module.exports = __webpack_public_path__ + "static/media/Youtube.24da5d01.svg";